export default function reduxListener(eventName, handler) {
	return (store) => (next) => (action) => {
		if (action.type === eventName) {
			handler(action, store);
		}
		return next(action);
	};
}
